/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CreditCardStack = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 7V21H5V18.5H6.5V19.5H21.5V8.5H20.5V7H23ZM19 3V17H1V3H19ZM2.5 8.5V15.5H17.5V8.5H2.5ZM10 12.5V14H4V12.5H10ZM17.5 4.5H2.5V6H17.5V4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
